/* Shopify selling-plan controls for the cart drawer. Event delegation survives section refreshes. */
(() => {
  'use strict';

  const cartRoot = () => window.Shopify?.routes?.root || '/';

  document.addEventListener('click', async event => {
    const toggle = event.target.closest('[data-mw-purchase-toggle]');
    if (toggle) {
      const purchase = toggle.closest('[data-mw-purchase]');
      if (purchase?.closest('[data-mw-busy="true"]')) return;
      const options = purchase?.querySelector('.mw-cart__purchase-options');
      if (!options) return;
      event.preventDefault();
      options.hidden = !options.hidden;
      toggle.setAttribute('aria-expanded', String(!options.hidden));
      return;
    }

    const option = event.target.closest('[data-mw-plan]');
    if (!option) return;
    const purchase = option.closest('[data-mw-purchase]');
    if (!purchase || purchase.dataset.busy === 'true' || purchase.closest('[data-mw-busy="true"]')) return;
    event.preventDefault();
    if (option.classList.contains('is-selected')) {
      purchase.querySelector('[data-mw-purchase-toggle]')?.click();
      return;
    }

    const line = Number(purchase.dataset.line);
    const quantityInput = purchase.closest('.mw-cart__item')?.querySelector('.mw-cart__qty-input');
    const quantity = Number(quantityInput?.value ?? purchase.dataset.quantity);
    const sellingPlan = option.dataset.mwPlan ? Number(option.dataset.mwPlan) : null;
    if (!Number.isInteger(line) || line < 1 || !Number.isInteger(quantity) || quantity < 1 || (sellingPlan !== null && !Number.isInteger(sellingPlan))) return;

    const itemKey = purchase.dataset.itemKey;
    const busyItem = window.mwCartItemBusy?.start(itemKey);
    if (busyItem === false) return;
    purchase.dataset.busy = 'true';
    const errorBox = purchase.closest('.mw-cart__item')?.querySelector('.mw-cart__item-error');
    errorBox?.classList.add('hidden');
    try {
      await window.mwCart.run(async () => {
      const helper = window.Alpine.store('xCartHelper');
      const currentLine = await window.mwCart.resolveLine(itemKey);
      const response = await fetch(`${cartRoot()}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: currentLine, quantity, selling_plan: sellingPlan, sections: helper.getSectionsToRender().slice(0, 5).map(section => section.id), sections_url: window.location.pathname })
      });
      const data = await response.json();
      if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || 'Could not update purchase option.');
      await helper.reRenderSections(data.sections);
      helper.syncCount(data);
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      });
    } catch (error) {
      console.error('Cart purchase option error:', error);
      if (errorBox) {
        const message = errorBox.querySelector('.cart-item__error-text');
        if (message) message.textContent = error.message || 'Could not update purchase option. Please try again.';
        errorBox.classList.remove('hidden');
      }
    } finally {
      purchase.dataset.busy = 'false';
      const refreshedKey = document.querySelector(`#CartDrawer [data-mw-purchase][data-line="${line}"]`)?.dataset?.itemKey || itemKey;
      window.mwCartItemBusy?.finish(refreshedKey, busyItem);
    }
  });
})();
